import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import type { SiteSettings } from '../types';

type ImageKey = keyof Pick<SiteSettings, 'hero_image_contact' | 'hero_image_management' | 'hero_image_properties'>;

interface Props {
  imageKey: ImageKey;
  fallbackClass: string;
  height?: string;
  overlay?: string;
  children: React.ReactNode;
}

export default function ImageHero({
  imageKey,
  fallbackClass,
  height = 'h-[420px]',
  overlay = 'bg-black bg-opacity-20',
  children,
}: Props) {
  const [image, setImage] = useState('');
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let active = true;
    api
      .get<Partial<SiteSettings>>('/settings')
      .then((s) => {
        if (!active) return;
        if (s[imageKey]) setImage(s[imageKey]);
        setReady(true);
      })
      .catch(() => {
        if (active) setReady(true);
      });
    return () => {
      active = false;
    };
  }, [imageKey]);

  return (
    <section className={`relative overflow-hidden ${height}`}>
      {ready && image ? (
        <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover" />
      ) : (
        <div className={`absolute inset-0 bg-cover bg-center ${fallbackClass}`} />
      )}
      <div className={`absolute inset-0 ${overlay}`} />
      <div className="relative h-full">{children}</div>
    </section>
  );
}
